function InfoIcon(props)
{
    return(
        <svg className={props.class?props.class:''} viewBox="0 0 24 24" width="1rem" height="1rem" fill="white"><g id="_26.Information" data-name="26.Information"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z"/><polygon points="15 19 11 19 11 11 9 11 9 9 13 9 13 17 15 17 15 19"/><rect x="11" y="5" width="2" height="2"/></g></svg>
    )
}

export default InfoIcon